export function hexToRgba(hex, opacity) {
    // Rimuovi il carattere '#' se presente
    hex = hex.replace(/^#/, '');

    // Converte il colore hex in valori RGB
    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;

    // Restituisce il colore in formato RGBA
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}